import { CustomerOnboardingAutomation } from "@/components/onboarding/CustomerOnboardingAutomation";

export default function CustomerOnboarding() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Customer Onboarding</h1>
        <p className="text-muted-foreground">
          Automate and manage customer onboarding workflows
        </p>
      </div>
      <CustomerOnboardingAutomation />
    </div>
  );
}
